import { ApiCallState } from "../Utils";

export type User = {
  id: number;
  full_name: string;
  email: string;
  role: string;
  is_super_user: boolean;
  phone_number: string;
  company: Company;
  chat_id: string;
  signature: Signature | null;
  access_type: "contractor" | "client" | "consultant";
  modules_subscribed: string[];
  last_seen: any;
  status: string;
};

export type Company = {
  id: number;
  name: string;
  type: string;
  category: string;
  address: string;
  country: string;
};

export type Signature = {
  id: number;
  signature_url: string;
};

export type UserStateTypes = {
  fetchAll: ApiCallState<User[]>;
  fetchAllAll: ApiCallState<User[]>;
  fetchOne: ApiCallState<User | {}>;
  fetchLoggedIn: ApiCallState<User | {}>;
};

export const UserActionTypes = {
  FETCH_ALL_USER: "FETCH_ALL_USER",
  FETCH_ALL_USER_RESET: "FETCH_ALL_USER_RESET",
  FETCH_ALL_USER_FAILURE: "FETCH_ALL_USER_FAILURE",
  FETCH_ALL_USER_SUCCESS: "FETCH_ALL_USER_SUCCESS",

  FETCH_ALL_ALL_USER: "FETCH_ALL_ALL_USER",
  FETCH_ALL_ALL_USER_RESET: "FETCH_ALL_ALL_USER_RESET",
  FETCH_ALL_ALL_USER_FAILURE: "FETCH_ALL_ALL_USER_FAILURE",
  FETCH_ALL_ALL_USER_SUCCESS: "FETCH_ALL_ALL_USER_SUCCESS",

  FETCH_ONE_USER: "FETCH_ONE_USER",
  FETCH_ONE_USER_RESET: "FETCH_ONE_USER_RESET",
  FETCH_ONE_USER_FAILURE: "FETCH_ONE_USER_FAILURE",
  FETCH_ONE_USER_SUCCESS: "FETCH_ONE_USER_SUCCESS",

  FETCH_LOGGED_IN_USER: "FETCH_LOGGED_IN_USER",
  FETCH_LOGGED_IN_USER_RESET: "FETCH_LOGGED_IN_USER_RESET",
  FETCH_LOGGED_IN_USER_FAILURE: "FETCH_LOGGED_IN_USER_FAILURE",
  FETCH_LOGGED_IN_USER_SUCCESS: "FETCH_LOGGED_IN_USER_SUCCESS",
};
